import Util from '../../util';
import { syncAddUserInfo, getTempInfo } from '../../common.js';
import { getCwimUserHqtCard } from './userInfoAction';

export const bankCardList = (text)=>{
	return {
		type: 'BANK_CARD_LIST',
		text
	}
}

export const bankCardNum = (text)=>{
	return {
		type: 'BANK_CARD_NUM',
		text
	}
}

export const HQTCardList = (text)=>{
	return {
		type: 'HQT_CARD_LIST',
		text
	}
}

export const bankCardListResetPS = (text)=>{
	return {
		type: 'BANK_CARD_LIST_RESET',
		text
	}
}

//获取用户银行卡列表
export const getCardList = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
				// let resHqtCard = await getCwimUserHqtCard(params)
				dispatch(bankCardList(succ.content.bankCard));
				dispatch(HQTCardList(succ.content.HqtCard));
				let opt = JSON.parse(JSON.stringify(succ));
		        let newData = stateAbleOrNot("", opt.content.HqtCard);
		        let allAbleVolume = 0;
		        let tempArr = [];
		        for(let i = 0; i < newData.length; i++) {
					allAbleVolume += newData[i].availableVolume;
					if(newData[i].trustChannelDisplayName == "招商银行在线支付" && newData[i].ywt == true) {

					}else if(newData[i].trustChannelDisplayName == "招商银行在线支付" && newData[i].ywt == false) {
						tempArr.push(newData[i]);
						newData.splice(i, 1);
					}else {
						if((newData[i].trustChannelDisplayName == "招商银行在线支付" && !newData[i].enableCMBTrustChannel) || newData[i].enableCMBTrustChannel === "0") {
						  tempArr.push(newData[i]);
						  newData.splice(i, 1);
						}
					}
				}
				if(tempArr.length > 0) {
					for(let j=0; j<tempArr.length; j++){
						newData.push(tempArr[j]);
					}
				}
				dispatch(hqtCardList(newData));

				succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
			console.log(err);
			errcallback(Util.errorTxt);
		};
		Util.post(Util.url + '/api/paymentaccount/getCardList', params, successCallback, errorCallback);
	}
}

export const  hqtCardList = (text)=>{
  return {
    type: 'HQT_CARD_LIST',
    text
  }
}
function stateAbleOrNot(argument,argumentTwo){
  let tempData = argumentTwo;
  // for (let i = 0; i < tempData.length; i++) {
	 //  for (let j =0; j < argument.length ;j++) {
	 //    if(tempData[i].trustChannelId == "888" && argument[j].trustChannelId == "888") {
	 //      if(tempData[i].bankCode == argument[j].bankCode && tempData[i].bankAccountShowNo != argument[j].bankAccountShowNo) {
	 //        tempData[i].bankAccountShowNo2 = argument[j].bankAccountShowNo;
	 //        if(tempData[i].bankCode != "007") {
	 //          tempData[i].enableCMBTrustChannel = "0";
	 //        }
	 //      }
	 //    }else {
	 //      if(argument[j].trustChannelId != "888") {
	 //        if(tempData[i].bankCode == argument[j].bankCode && tempData[i].bankAccountShowNo != argument[j].bankAccountShowNo) {
	 //          tempData[i].bankAccountShowNo2 = argument[j].bankAccountShowNo;
	 //          if(tempData[i].bankCode != "007") {
	 //        	tempData[i].enableCMBTrustChannel = "0";
	 //          }
	 //        }
	 //      }
	 //    }
	 //  }  
  // }
  tempData.sort(getVal('availableVolume'));
  return tempData
}
let getVal= (property) => {
    return function(a,b){
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
    }
}

//获取用户银行卡数量
export const getCardListAmount  = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
				dispatch(bankCardNum(succ.content));
				sessionStorage.setItem("myCardNum", JSON.stringify(succ.content));
				succallback();
			}else{
				console.log('后台返回数据有误！' + succ.message);
				let myCardNum = sessionStorage.getItem("myCardNum");
				if(myCardNum){
					dispatch(bankCardNum(JSON.parse(myCardNum)));
				}else{
					dispatch(bankCardNum('--'));
				}
				errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
			let myCardNum = sessionStorage.getItem("myCardNum");
			if(myCardNum){
				dispatch(bankCardNum(JSON.parse(myCardNum)));
			}else{
				dispatch(bankCardNum('--'));
			}
			console.log(err);
			errcallback(Util.errorTxt);
		};
		Util.post(Util.url + '/api/paymentaccount/getCardListAmount', params, successCallback, errorCallback);
	}
}

//请求加卡
export const addCardRequest = (params, succallback, errcallback)=>{
	return async (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
				succallback();
			}else{
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
			console.log(err);
			errcallback(Util.errorTxt);
		};
		params.token = await getTempInfo('shortToken');
		Util.post(Util.url + '/api/account/addCardRequest', params, successCallback, errorCallback);
	}
}

//获取卡类型
export const getBankCardType = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
				succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
			console.log(err);
			errcallback(Util.errorTxt);
		};
		Util.post(Util.url + '/api/realnameauth/getBankName', params, successCallback, errorCallback);
	}
}

//获取可加卡银行的列表来取得paymentChannelId
export const getBankList = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
				succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
			console.log(err);
			errcallback(Util.errorTxt);
		};
		Util.post(Util.url + '/api/realnameauth/getBankCardList', params, successCallback, errorCallback);
	}
}

//鉴权申请
export const requestAuthentication = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
				succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
			console.log(err);
			errcallback(Util.errorTxt);
		};
		Util.post(Util.url + '/api/realnameauth/authApplyRequest', params, successCallback, errorCallback);
	}
}

//鉴权确认
export const confirmAuthentication = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
				succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
			console.log(err);
			errcallback(Util.errorTxt);
		};
		Util.post(Util.url + '/api/realnameauth/authConfirm', params, successCallback, errorCallback);
	}
}
//添加银行卡
export const addBankCard = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
				succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
			console.log(err);
			errcallback(Util.errorTxt);
		};
		Util.post(Util.url + '/api/account/addCardRequest', params, successCallback, errorCallback);
	}
}
//解绑银行卡
export const unbindBankCard = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
				succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
			console.log(err);
			errcallback(Util.errorTxt);
		};
		Util.post(Util.url + '/api/account/closePaymentAccount', params, successCallback, errorCallback);
	}
}
//获取常见问题
export const getFAQ = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ){
				succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.responseMsg);
				errcallback(succ.responseMsg);
			}
		};
		const errorCallback = (err)=>{
			console.log(err);
			errcallback(Util.errorTxt);
		};
		Util.post(Util.url + '/api/cms/getQuestionListByCode', params, successCallback, errorCallback);
	}
}
//验证交易密码
export const validateTransactionPassword = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
				succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
			console.log(err);
			errcallback(Util.errorTxt);
		};
		Util.post(Util.url + '/api/account/validatePassword', params, successCallback, errorCallback);
	}
}

//获取可以重置交易密码的银行卡
export const getCardListForResetTradePassword = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
				dispatch(bankCardListResetPS(succ.content));
				succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
			console.log(err);
			errcallback(Util.errorTxt);
		};
		Util.post(Util.url + '/api/account/getResetPasswordChannels', params, successCallback, errorCallback);
	}
}





// WEBPACK FOOTER //
// ./src/action/myAssets/myCardAction.js